import CloseIcon from "@mui/icons-material/Close";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Drawer,
  Grid,
  IconButton,
  Modal,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";

import { format } from "date-fns";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAllSessionLicenseActive,
  getAllUserDetails,
  getSessionCloseDetails,
  getSessionData,
  holdCartListSession,
} from "../../../../../../config/Services";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import { SessionPage } from "../../sessionPage";
import SummaryCard from "./components/SummaryCard/SummaryCard";
import "./index.css";
import { convertToLocalTime } from "../../../all-products/Middleware/commonUtils";
import { useDispatch } from "react-redux";
import { addmanagerpin, addpin } from "../../../all-products/redux/Actions/SessionActions";
import ClosingHoldModal from "../../../all-products/components/ClosingHoldModal/ClosingHoldModal";
import PreviousSessionMessage from "./components/previousSession";
import { customEventTrigger } from "../../../../../../analytics";
import Navbar from "../../../../posnavbar/Navbar";
import SessionPageLeft from "../../../sessionPageV2/SessionPageLeft";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { ArrowLongRightIcon } from "@heroicons/react/24/solid";

export const SessionListingV2 = () => {
  const showSnackbar = useSnackbar();
  const isMobile = useGetDevice();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get session and organization info from localStorage
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const sessionId = localStorage.getItem("sessionId");
  const licenseId = localStorage.getItem("licenseId");
  const mode = localStorage.getItem("mode");

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openHoldModal, setOpenHoldModal] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  const retailType = localStorage.getItem("retailType");

  // Mutation to check for hold carts before stopping the session
  const { isLoading: isHoldCartLoading, mutate: checkHoldCartList } = useMutation({
    mutationFn: async (data) => {
      const response = await holdCartListSession(data);
      return response?.data?.data;
    },
    onSuccess: (data) => {
      if (!!data?.length) {
        setOpenHoldModal(true);
      } else {
        navigate("/session-page/denominations");
      }
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  /**
   * Handles the stop session workflow.
   * Checks for hold carts, triggers analytics, and resets session pins in Redux.
   */
  const handleStopDay = () => {
    const payload = {
      sourceLocationId: locId,
      destinationId: locId,
      loggedInUser: uidx,
    };
    customEventTrigger("pos_stop_session_button", {
      pos_user_id: payload.loggedInUser,
    });
    checkHoldCartList(payload);
    dispatch(addpin(""));
    dispatch(addmanagerpin(""));
  };

  const { data: summaryData } = useQuery({
    refetchOnWindowFocus: false,
    retry: 1,
    queryKey: ["sessionCloseDetails"],
    queryFn: async () => {
      const res = await getSessionCloseDetails(locId, licenseId, sessionId);
      if (res?.data?.code === "ECONNRESET") {
        throw new Error(res?.data?.message);
      }
      if (res?.data?.data?.es) {
        throw new Error(res?.data?.data?.message);
      }
      return res?.data?.data?.sessionData?.sessionSalesData;
    },
    onError: (err) => {
      showSnackbar(err?.message || err?.response?.data?.message, "error");
    },
  });

  // Fetch session data on mount
  useEffect(() => {
    fetchSessionData();
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };

  /**
   * Fetches session data for the current day.
   */
  const fetchSessionData = () => {
    const currentDate = format(new Date(), "yyyy-MM-dd");

    const payload = {
      pageNumber: 0,
      pageSize: 10,
      sortOrder: "ASCENDING",
      organizationId: orgId,
      locationId: locId,
      startDate: currentDate,
      endDate: currentDate,
    };
    getSessionData(payload)
      .then((res) => {
        if (res?.data?.es) {
          throw new Error(res?.data?.message);
        }
        // showSnackbar(res?.data?.message, "success");
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  // to get all session active for particular licenseId

  const [sessionTable, setSessionTable] = useState([]);
  const [previousDay, setPreviousDay] = useState(false);
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const uidx = retailUserDetails?.uidx;

  // Separate active and inactive sessions
  const activeSessions = sessionTable?.filter((session) => session?.status === "ACTIVE") || [];
  const inactiveSessions = sessionTable?.filter((session) => session?.status !== "ACTIVE") || [];

  useEffect(() => {
    if (licenseId) {
      getAllSessionLicenseActive(licenseId).then((res) => {
        if (res.data.message === "USER_SESSION_DO_NOT_EXIST" && res.data.es == 1) {
          setPreviousDay(true);
          return;
        }
        if (res?.data?.sessions) {
          setPreviousDay(false);
          const uidxList = res?.data?.sessions?.map((item) => item?.uidx);
          const payload = { uidx: uidxList };
          getAllUserDetails(payload).then((resp) => {
            const sessionsWithNames = res?.data?.sessions?.map((item, i) => {
              return {
                ...item,
                name: resp?.data?.data[i]?.firstName,
              };
            });

            // Sort to show active user (current uidx) on top
            const sortedSessions = sessionsWithNames?.sort((a, b) => {
              if (a?.uidx === uidx) return -1;
              if (b?.uidx === uidx) return 1;
              return 0;
            });

            setSessionTable(sortedSessions);
          });
        }
      });
    }
  }, [licenseId, uidx]);

  /**
   * Navigates to the cart page.
   * Triggers analytics event and routes based on device type and retail type.
   */
  const goToCart = () => {
    customEventTrigger("pos_go_to_cart");
    const branchSubType = localStorage.getItem("branchSubType");
    if (retailType === "RESTAURANT" && branchSubType === "FINE_DINE") {
      navigate("/products/table-layout");
    } else if (isMobile || retailType === "RESTAURANT") {
      navigate("/restaurant/cart");
    } else {
      navigate("/grocery/cart");
    }
  };

  const tableWrapperStyle = {
    maxHeight: "300px",
    overflowY: "auto",
    overflowX: "hidden",
  };

  const activeUserRowStyle = {
    backgroundColor: "#e3f2fd",
    fontWeight: 600,
  };

  // Render session table rows
  const renderSessionRows = (sessions) => {
    return sessions?.map((item, i) => {
      return (
        <tr key={i} style={item?.uidx === uidx ? activeUserRowStyle : {}}>
          <td className="table-data-pos">{item?.name}</td>
          <td className="table-data-pos">{item?.licenseName}</td>
          <td className="table-data-pos">{item?.licenseId}</td>
          <td className="table-data-pos">{convertToLocalTime(item?.startTime)}</td>
          <td className="table-data-pos">
            {item?.endTime ? convertToLocalTime(item?.endTime) : "Ongoing"}
          </td>
          <td className={item?.status === "CLOSED" ? "table-data-posRed" : "table-data-posGreen"}>
            {item?.status}
          </td>
        </tr>
      );
    });
  };

  return (
    <Navbar>
      <style>
        {`
          .table-scroll-wrapper::-webkit-scrollbar {
            width: 8px;
          }
          
          .table-scroll-wrapper::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          
          .table-scroll-wrapper::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
          }
          
          .table-scroll-wrapper::-webkit-scrollbar-thumb:hover {
            background: #555;
          }

          .session-accordion {
            margin-top: 12px;
            box-shadow: none;
            border: 1px solid #e0e0e0;
            border-radius: 4px !important;
          }

          .session-accordion:before {
            display: none;
          }

          .accordion-summary {
            background-color: #f5f5f5;
            min-height: 48px !important;
          }

          .accordion-summary .MuiAccordionSummary-content {
            margin: 8px 0;
          }
        `}
      </style>
      <Modal
        open={openHoldModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-popup"
      >
        <ClosingHoldModal setOpenHoldModal={setOpenHoldModal} />
      </Modal>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <SessionPageLeft />
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="newSessionRightContainer">
              <div className="newSessionListingContainer">
                <div className="newSessionRightInnerContainer">
                  <p className="startText">Active Sessions</p>
                  {sessionTable && !previousDay ? (
                    <>
                      {/* Active Sessions Table */}
                      {activeSessions.length > 0 ? (
                        <div className="table-scroll-wrapper" style={tableWrapperStyle}>
                          <table className="pos-table-main-box-new">
                            <thead>
                              <tr>
                                <th className="table-head-pos">Cashier Name</th>
                                <th className="table-head-pos">Billing Counter</th>
                                <th className="table-head-pos">License ID</th>
                                <th className="table-head-pos">Start Time</th>
                                <th className="table-head-pos">End Time</th>
                                <th className="table-head-pos">Status</th>
                              </tr>
                            </thead>
                            <tbody>{renderSessionRows(activeSessions)}</tbody>
                          </table>
                        </div>
                      ) : (
                        <Typography sx={{ textAlign: "center", py: 2, color: "#666" }}>
                          No active sessions
                        </Typography>
                      )}

                      {/* Inactive Sessions Accordion */}
                      {inactiveSessions.length > 0 && (
                        <Accordion
                          className="session-accordion"
                          expanded={accordionExpanded}
                          onChange={() => setAccordionExpanded(!accordionExpanded)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="accordion-summary"
                          >
                            <Typography sx={{ fontWeight: 500 }}>
                              Other Sessions ({inactiveSessions.length})
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails sx={{ padding: 0 }}>
                            <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                              <table className="pos-table-main-box-new">
                                <thead>
                                  <tr>
                                    <th className="table-head-pos">Cashier Name</th>
                                    <th className="table-head-pos">Billing Counter</th>
                                    <th className="table-head-pos">License ID</th>
                                    <th className="table-head-pos">Start Time</th>
                                    <th className="table-head-pos">End Time</th>
                                    <th className="table-head-pos">Status</th>
                                  </tr>
                                </thead>
                                <tbody>{renderSessionRows(inactiveSessions)}</tbody>
                              </table>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </>
                  ) : (
                    <PreviousSessionMessage />
                  )}
                </div>
                <div className="newSessionListingButtonContainer">
                  <PosCustomButton
                    title="Stop session"
                    width="50%"
                    p={"12px 16px"}
                    radius="4px"
                    variant="red-transparent"
                    loading={isHoldCartLoading}
                    onClickFunction={handleStopDay}
                  />
                  <PosCustomButton
                    title="Go to cart"
                    width="100%"
                    p={"12px 16px"}
                    radius="4px"
                    variant="blue-d"
                    onClickFunction={goToCart}
                    iconOnRight={
                      <PosCustomIcon
                        icon={<ArrowLongRightIcon />}
                        height={"1rem"}
                        width={"1rem"}
                        color="var(--surface-white)"
                      />
                    }
                    iconPosition={"corner"}
                  />
                </div>
                <Drawer
                  anchor="bottom"
                  open={drawerOpen}
                  onClose={toggleDrawer(false)}
                  sx={{ zIndex: "1201" }}
                  PaperProps={{
                    style: {
                      backgroundColor: "#ececec",
                      borderRadius: "10px",
                      margin: !isMobile && "2rem",
                    },
                  }}
                >
                  <Box className="summary-main-box">
                    <div className="summary-title">Session Summary</div>
                    <SummaryCard data={summaryData} />
                  </Box>

                  <Box className="summary-close-button" onClick={toggleDrawer(false)}>
                    <IconButton aria-label="delete">
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Drawer>
                <div className="summary-button-wrapper">
                  <PosCustomButton
                    title="Summary"
                    radius="4px"
                    p={"12px 16px"}
                    variant="blue-d"
                    onClickFunction={toggleDrawer(true)}
                    iconOnLeft={
                      <PosCustomIcon
                        icon={<CurrencyRupeeIcon />}
                        color="white"
                        height={"14px"}
                        width={"14px"}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Navbar>
  );
};
